import React, { useState } from "react";
import "./Login.css";

const API_URL =
  process.env.REACT_APP_API_URL ||
  (["localhost", "127.0.0.1"].includes(window.location.hostname)
    ? "http://localhost:5003"
    : window.location.origin);

export default function Login({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const response = await fetch(`${API_URL}/api/auth/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          email: email.trim(),
          password
        })
      });

      const data = await response.json();

      if (!response.ok || !data.token) {
        throw new Error(data.message || "Login failed");
      }

      sessionStorage.setItem("softvolute_token", data.token);
      localStorage.setItem("token", data.token);
      onLogin(data.user);
    } catch (err) {
      setError(err.message || "Unable to connect to server");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-left">
        <div className="brand">
          <div className="brand-icon">S</div>
          <div>
            <h2>SOFTVOLUTE</h2>
            <span>BUILDING BETTER SPACES</span>
          </div>
        </div>

        <div className="login-left-content">
          <div className="eyebrow">ENTERPRISE MANAGEMENT</div>
          <h1>
            One Platform.
            <br />
            Complete Control.
          </h1>
          <p>
            Streamline projects, employees, finances,
            inventory and business operations through
            one integrated ERP platform.
          </p>
          <div className="brand-line" />
          <div className="feature-pills">
            <span>Project Management</span>
            <span>Finance & Accounts</span>
            <span>Team Collaboration</span>
          </div>
        </div>

        <div className="login-left-footer">
          © {new Date().getFullYear()} Softvolute. All rights reserved.
        </div>
      </div>

      <div className="login-right">
        <div className="login-form-container">
          <div className="mobile-brand">SOFTVOLUTE ERP</div>

          <div className="welcome-badge">
            SECURE EMPLOYEE PORTAL
          </div>

          <h2>Welcome Back</h2>
          <p className="login-subtitle">
            Sign in to access your workspace.
          </p>

          <form onSubmit={handleLogin}>
            <div className="form-group">
              <label htmlFor="email">Email Address</label>
              <input
                id="email"
                type="email"
                placeholder="name@company.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="username"
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Password</label>
              <div className="password-field">
                <input
                  id="password"
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter your password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  autoComplete="current-password"
                />
                <button
                  type="button"
                  className="password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? "Hide" : "Show"}
                </button>
              </div>
            </div>

            {error && (
              <div className="login-error" role="alert">
                {error}
              </div>
            )}

            <button
              type="submit"
              className="login-submit"
              disabled={loading}
            >
              {loading ? "Signing in..." : "Sign In"}
              {!loading && <span>→</span>}
            </button>
          </form>

          <div className="login-help">
            Need access? Contact your ERP administrator.
          </div>

          <div className="login-security">
            <span>●</span> Secure ERP Access
          </div>
        </div>
      </div>
    </div>
  );
}